import type { BlockId, CustomBlockConfig } from '../blocks/types';

// What each curated variant looks like. Cozy is the new default; Focused
// strips the fun stuff for power users; Classic mirrors the v1 launcher.

export const COZY_BLOCKS: BlockId[] = [
  'hero',
  'ai-ask',
  'vital-signs',
  'fun-zone',
  'for-you',
  'on-your-mind',
  'pinned',
  'all-apps-link',
];

export const FOCUSED_BLOCKS: BlockId[] = [
  'hero', // compact mode applied in the renderer
  'ai-ask',
  'vital-signs',
  'pinned',
  'all-apps-link',
];

// Classic mirrors v1: just the existing launcher + announcements + widgets.
export const CLASSIC_BLOCKS: BlockId[] = [
  'whats-new',
  'vital-signs',
  'announcements',
  'pinned',
  'all-apps-grid',
];

// Starting point for new Custom users — clones Cozy with all blocks visible.
export const defaultCustomLayout = (): CustomBlockConfig[] =>
  COZY_BLOCKS.map((id) => ({ id, visible: true }));
